import { format, formatDistanceToNow, isValid } from 'date-fns';
import { ptBR } from 'date-fns/locale';

export const normalizeDateInputValue = (value?: string | null) => {
    if (!value) return '';
    if (!value.includes('T')) return value;

    const parsed = new Date(value);
    if (!isValid(parsed)) return '';

    return format(parsed, 'yyyy-MM-dd');
};

const parseDateOnly = (value?: string | null): Date | null => {
    if (!value) return null;

    const [datePart] = value.split('T');
    const [year, month, day] = datePart.split('-').map(Number);

    if (!year || !month || !day) return null;

    return new Date(year, month - 1, day);
};

export const formatDateOnly = (value?: string | null, fallback = '-') => {
    if (!value) return fallback;

    const parsedDateOnly = parseDateOnly(value);
    if (parsedDateOnly) {
        return format(parsedDateOnly, 'dd/MM/yyyy', { locale: ptBR });
    }

    const parsed = new Date(value);
    if (!isValid(parsed)) return fallback;

    return format(parsed, 'dd/MM/yyyy', { locale: ptBR });
};

/** "há 3 dias", "em 2 meses" — the relative phrasing used across the app. */
export const formatRelativeToNow = (value?: string | null, fallback = '-') => {
    if (!value) return fallback;

    const parsed = new Date(value);
    if (!isValid(parsed)) return fallback;

    return formatDistanceToNow(parsed, { addSuffix: true, locale: ptBR });
};
